module.exports = __webpack_public_path__ + "static/img/068_TO8_1693.32535ec.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/068_TO8_1693.jpg
// module id = u3ic
// module chunks = 0